export default __webpack_public_path__ + "static/media/u3.1cbc6353.png";